import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

import { FaWhatsapp as WhatsappIcon } from "@react-icons/all-files/fa/FaWhatsapp";
import { FaTelegramPlane as TelegramIcon } from "@react-icons/all-files/fa/FaTelegramPlane";

import { IHost } from "@Interfaces";

import { useIsMounted } from "repoV2/utils/common/render/mount";
import { CONTACT_KEYS, SELECTORS, useData } from "@Utils";
import { classNames } from "repoV2/utils/common/render/classNames";
import ContactWidgetFloatModal from "@Modules/ContactWidgetFloatModal";
import useCompactStatusForEventPage from "@Modules/eventPage/utils/useCompactStatusForEventPage";
import styles from "./contactWidget.module.scss";

const ContactWidget = (): JSX.Element | null => {
    const [isOpen, setOpen] = useState<boolean>(false);
    const router = useRouter();
    const isMounted = useIsMounted();

    const hostData = useSelector(SELECTORS.hostData) || ({} as IHost.IHostData);
    const modalInfo = useSelector(SELECTORS.modalInfo);
    const communityAppData = useSelector(SELECTORS.communityAppData);

    const { data: hideContactWidget } = useData("hideContactWidget");
    const isCompactEventPage = useCompactStatusForEventPage();
    const isTelegram = hostData.contact_mode === CONTACT_KEYS.Telegram;

    // TODO: Implement ROUTER enum instead of hardcoded string
    const isEventPage: boolean = router.route === "/event";

    if (
        !isMounted ||
        (
            ["none", "only_booked_user"] as Array<typeof hostData.contact_mode>
        ).includes(hostData.contact_mode) ||
        !hostData.contact_url ||
        modalInfo.isModalOpen ||
        hideContactWidget ||
        communityAppData ||
        isCompactEventPage
    )
        return null;

    return (
        <div
            className={classNames(
                styles.root,
                isTelegram && styles.telegram,
                isOpen && styles.isOpen,
                isEventPage && styles.isEventPage
            )}
        >
            <ContactWidgetFloatModal
                isOpen={isOpen}
                hostData={hostData}
                setOpen={setOpen}
                isTelegram={isTelegram}
            />
            <div
                className={styles.floatIcon}
                onClick={() => {
                    setOpen(!isOpen);
                }}
            >
                {isTelegram ? <TelegramIcon /> : <WhatsappIcon />}
            </div>
        </div>
    );
};

export default ContactWidget;
